<template>
    <div class="footer">

    </div>
  </template>
  
  <script>
  
  export default {
	props: {

	},
    data () {
        return {
        }
    },
    methods: {

    },
    name: 'Footer',
    components: {

    }
  }
  </script>
<style scoped>

.footer {
background-color: #eeeeee;
}

</style>
  